import { bus } from '../bus'

import TemplateModel from './model/Template'
import TemplateWindow from './windows/TemplateWindow'

export default {
	async save(comp, entity) {
		//await TemplateModel.save(comp.axios, entity);
	},
	async open(comp, id) {
		var self 	= comp;
		var model	= TemplateModel;
		var win 	= TemplateWindow;
		var ent 	= id ? await model.read(self.axios, id) : model.entity();

		/*if (!id) {
			ent.employee_id 		= self.$store.state.employee.id;
			ent.department_id 		= self.$store.state.employee.department_id;
			ent._embedded.employee	= self.$store.state.employee;
			//ent.type				= type;
		}*/

		self.$store.state.windowStack.push(win, {
			value: ent,
			async submit(entity) {
				if (await model.save(self.axios, entity)) {
					self.$store.state.windowStack.pop();
					bus.$emit('update-template');
				}
			}
		});
	},
	async copy(comp, id) {
		var self 	= comp;
		var model	= TemplateModel;
		var win 	= TemplateWindow;
		var ent 	= id ? await model.read(self.axios, id) : model.entity();

		delete ent.id;

		/*if (!id) {
			ent.employee_id 		= self.$store.state.employee.id;
			ent.department_id 		= self.$store.state.employee.department_id;
			ent._embedded.employee	= self.$store.state.employee;
			//ent.type				= type;
		}*/

		self.$store.state.windowStack.push(win, {
			value: ent,
			async submit(entity) {
				if (await model.save(self.axios, entity)) {
					self.$store.state.windowStack.pop();
					bus.$emit('update-template');
				}
			}
		});
	},
	async delete(comp, id) {
		await TemplateModel.delete(comp.axios, id);
		bus.$emit('update-template');
	}
};